import { render, staticRenderFns } from "./AboutWe.vue?vue&type=template&id=591071c5&scoped=true&"
import script from "./AboutWe.vue?vue&type=script&lang=js&"
export * from "./AboutWe.vue?vue&type=script&lang=js&"
import style0 from "./AboutWe.vue?vue&type=style&index=0&id=591071c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591071c5",
  null
  
)

export default component.exports